import { push } from "connected-react-router";
import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  APPLICATION_MODE_NEW,
  APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
  APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
  LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION,
  APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE,
  // APPLICATION_MODE_NEW,
  // APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE,
  ROUTE_PATH,
  LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION,
  LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION,
  LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL,
  LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL,
  APPLICATION_MODE_RENEW,
  LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION
} from "../../app/constants";
import {
  Header,
  Button,
  NavigationLinkButton,
  Paragraph,
  ErrorMark
} from "../../components/RegularComponents";

import TopNavigationBar from "../TopNavigationBar";
import { ERROR_STRING } from "../../app/errors";
import MraRJSCCompnayOfficalForm from "./MraRJSCCompanyOfficialForm";
import { setCompanyRjscDetails } from "../../redux/slice/rjscDetailReviewSlice";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { applicationTypeFromLicenceSubType } from "../../redux/slice/applicationsUtils";
import { replaceUrlParams } from "../../app/utils";

// const MORTGAGE_APPLICATION_PROPERTY = "uploadWorkHistory";

export const MraRJSCEnterCompanyOfficals = (props) => {
  //   const applicationType = APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE;
  //   const applicationMode = APPLICATION_MODE_NEW;

  //   const [applicationSaveError, setApplicationSaveError] = useState(false);

  //   const { principalBrokerApplication } = useSelector(
  //     mraPrincipalBrokerSelector
  //   );

  //   const uploadWorkHistory = useMemo(() => {
  //     return (
  //       principalBrokerApplication.businessLicenceData?.uploadWorkHistory ?? []
  //     );
  //   }, [principalBrokerApplication]);

  // This will change to primaryAgent when branch is pushed
  // const uploadWorkHistory = useSelector(
  //   (state) =>
  //     state.primaryAgencyApplication.application.businessLicenceData
  //       .uploadWorkHistory
  // );

  // array of objects with first/lastname and role

  const [formCheck, setFormCheck] = useState([false]);
  const [showValidationError, setShowValidationError] = useState(false);

  const { isModal = false, onEditSave = () => {} } = props;
  const dispatch = useDispatch();

  const companyRjscDetails = useSelector(
    (state) => state.primaryAgencyApplication?.application?.businessLicenceData?.companyRjscDetails
  );

  const licencingSubType = useSelector(
    (state) => state.primaryAgencyApplication?.application?.licencingSubType
  );

  const currentPeopleList = useMemo(() => {
    if (companyRjscDetails?.businessData?.peopleList.length > 0) {
      let personArray = [...companyRjscDetails?.businessData?.peopleList];

      return personArray.map((person) => {
        return { ...person };
      });
    }

    return [
      {
        firstName: null,
        lastName: null,
        position: "Director",
        entityId: "1"
      }
    ];
  }, [companyRjscDetails]);

  const [rjscCompanyOfficalsDetails, setRjscCompanyOfficalsDetails] = useState(currentPeopleList);

  const [personCount, setPersonCount] = useState(rjscCompanyOfficalsDetails.length);

  const SubSeparator = () => {
    return (
      <hr
        className="bottomMarginNormal"
        style={{
          borderColor: "#0058a466",
          borderWidth: "3px",
          width: "65%",
          marginLeft: "0px"
        }}
      />
    );
  };

  const validateData = () => {
    let error = false;

    //Iterate thorugh uploadWorkHistoryDetails
    rjscCompanyOfficalsDetails.forEach((element, index) => {
      if (!element.firstName || !element.lastName) {
        let updateFormCheck = [...formCheck];
        updateFormCheck[index] = true;
        setFormCheck(updateFormCheck);

        error = true;
      }
    });

    return error;
  };

  const handleSaveAndNext = () => {
    // setApplicationSaveError(false);

    //reset errors
    if (validateData()) {
      setShowValidationError(true);
      return;
    }

    // dispatch(
    //   setCurrentAgentMortgageProperty({
    //     key: MORTGAGE_APPLICATION_PROPERTY,
    //     value: uploadWorkHistoryDetails,
    //   })
    // );

    // On to the next item
    // dispatch(
    //   saveBusinessLicenceApplicationData(applicationType, applicationMode)
    // )
    //   .then((data) => {
    //     dispatch(
    //       push(
    //         `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_BROKER_LICENCE_IN_PROVINCES}`
    //       )
    //     );
    //   })
    //   .catch((err) => {
    //     setApplicationSaveError(true);
    //   });

    // finish navigation here

    const mergedBusinessData = {
      ...companyRjscDetails.businessData,
      peopleList: [...rjscCompanyOfficalsDetails]
    };

    dispatch(
      setCompanyRjscDetails({
        ...companyRjscDetails,
        businessData: mergedBusinessData
      })
    );

    let applicationType = APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE;
    let applicationMode = APPLICATION_MODE_NEW;

    let nextUrl = `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_BROKER_NEXT_STEPS}`;

    if (licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION) {
      applicationType = APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE;
      nextUrl = `${ROUTE_PATH.ML_APP}${ROUTE_PATH.ML_NEXT_STEPS}`;
    }
    else if(licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION) {
      applicationType = APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE;
      nextUrl = `${ROUTE_PATH.ML_APP}${ROUTE_PATH.RENEWAL_COMPLIANCE_OFFICER}`;
    }
    
    if (licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION) {
      applicationType = APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE;
      nextUrl = `${ROUTE_PATH.ML_APP}${ROUTE_PATH.ML_NEXT_STEPS}`;
    }
    else if(licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION) {
      applicationType = APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE;
      nextUrl = `${ROUTE_PATH.MA_APP}${ROUTE_PATH.RENEWAL_COMPLIANCE_OFFICER}`;
    }

    if (
      licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION ||
      licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL ||
      licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION ||
      licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL
    ) {
      applicationType = applicationTypeFromLicenceSubType(licencingSubType);
      let subURL;

      if (
        licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL ||
        licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL
      ) {
        subURL = ROUTE_PATH.APPLICATION_RENEWAL_REVIEW
        applicationMode = APPLICATION_MODE_RENEW;
      }
      else {
         subURL = ROUTE_PATH.BUSINESS_CONTACT
      }
      nextUrl = replaceUrlParams(subURL, applicationType, applicationMode);
    }

    if (!isModal) {
      dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode)).then(
        (data) => {
          dispatch(push(nextUrl));
        }
      );
    } else {
      onEditSave();
    }
  };

  const CompanyOfficalBlock = ({ data = [] }) => {
    return (
      <>
        {data.map((element, index) => (
          <>
            <div className="row">
              <div className="col-lg-6">
                <MraRJSCCompnayOfficalForm
                  firstName={element.firstName}
                  lastName={element.lastName}
                  role={element.position}
                  validationError={formCheck[index]}
                  index={index}
                  onSaveItem={(index, saveElement, field) => {
                    let rjscCompanyOfficalsDetailsUpdate = [...rjscCompanyOfficalsDetails];
                    rjscCompanyOfficalsDetailsUpdate[index][field] = saveElement;
                    setRjscCompanyOfficalsDetails(rjscCompanyOfficalsDetailsUpdate);

                    setShowValidationError(false);

                    // reset form check
                    let updateFormCheck = [...formCheck];
                    setFormCheck(updateFormCheck.map((x) => false));
                  }}
                />
              </div>{" "}
              <div className="col-lg-2">
                {index > 0 && (
                  <NavigationLinkButton
                    id={"branch-remove-link"}
                    text={"- Remove person"}
                    onClick={() => {
                      let rjscCompanyOfficalsDetailsUpdate = [...rjscCompanyOfficalsDetails];
                      rjscCompanyOfficalsDetailsUpdate.splice(index, 1);
                      setRjscCompanyOfficalsDetails(rjscCompanyOfficalsDetailsUpdate);

                      setShowValidationError(false);

                      let formCheckUpdate = [...formCheck];
                      formCheckUpdate.splice(index, 1);
                      setFormCheck(formCheckUpdate);
                    }}
                  />
                )}
              </div>
              <SubSeparator />
            </div>
          </>
        ))}
      </>
    );
  };

  return (
    <>
      <div className={!isModal ? "container" : ""}>
        {!isModal && (
          <>
            <TopNavigationBar hideSaveAndExit {...props} />
            <div className="row">
              <div className="col-xs-12 col-lg-9">
                <Header
                  style={{ paddingBottom: "30px" }}
                  id="company-fiscal-end-date-header"
                  header="Company Officials"
                />
                <Paragraph
                  style={{ paddingBottom: "10px" }}
                  id="company-fiscal-end-date-header"
                  text={[
                    "Enter information about company officials who are either directors, partners, officers, or sole proprietors for the company"
                  ]}
                />
              </div>
            </div>
          </>
        )}

        <CompanyOfficalBlock data={rjscCompanyOfficalsDetails} />

        <div className="row bottomMarginMedium">
          <div className={"col-lg-8"}>
            <NavigationLinkButton
              id={"rjsc-company-official-add-more-link"}
              text={"+ Add another person"}
              onClick={() => {
                const increment = personCount + 1;
                setPersonCount(increment);
                setRjscCompanyOfficalsDetails([
                  ...rjscCompanyOfficalsDetails,
                  {
                    firstName: null,
                    lastName: null,
                    position: "Director",
                    entityId: increment.toString()
                  }
                ]);
                setFormCheck([...formCheck, false]);
              }}
            />
          </div>
        </div>

        <div className="row">
          <div className={"col-lg-4"}>
            <Button
              id="company-fiscal-end-date-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={!isModal ? "Save and next" : "Save and close"}
              onClick={handleSaveAndNext}
            />
            {showValidationError && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.CHECK_FIELDS}
              </div>
            )}
            {/* {applicationSaveError && ErrorMark()}
            {applicationSaveError && (
              <div className="ns-error-message help-block topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )} */}
          </div>
        </div>
      </div>
    </>
  );
};
